import { asyncRoutes, constantRoutes } from '@/router'

/**
 * Use meta.permissionKey to determine if the current user has permission
 * @param routePermissions
 * @param route
 */
function hasPermission(routePermissions, route) {
  if (route.meta && route.meta.permissionKey) {
    return routePermissions.includes(route.meta.permissionKey)
  }
  return true
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param routePermissions
 */
export function filterAsyncRoutes(routes, routePermissions) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(routePermissions, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, routePermissions)
        if (!tmp.children.length) {
          return
        }
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, payload) {
    return new Promise(resolve => {
      const { roles = [], routePermissions = [] } = payload
      let accessedRoutes
      if (roles.includes('admin')) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, routePermissions)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
